function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFAE00",
  d: "M23.863 0v48L3.323 36.25l-.001-24.3L23.862 0zm.004 0l20.541 11.95-.001 24.3L23.867 48V0z",
  opacity: 0.196
}), /*#__PURE__*/React.createElement("path", {
  fill: "#66BF3C",
  d: "M8.99 28.72l7.969-4.637a14 14 0 0114.082 0l7.969 4.637a4 4 0 01.056 6.881l-7.828 4.728a14 14 0 01-14.476 0l-7.828-4.728a4 4 0 01.056-6.881z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFAE00",
  d: "M8.99 20.826l7.969-4.637a14 14 0 0114.082 0l7.969 4.637a4 4 0 01.056 6.881l-7.828 4.728a14 14 0 01-14.476 0l-7.828-4.728a4 4 0 01.056-6.881z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC521F",
  d: "M8.99 12.932l7.969-4.637a14 14 0 0114.082 0l7.969 4.637a4 4 0 01.056 6.881l-7.828 4.728a14 14 0 01-14.476 0l-7.828-4.728a4 4 0 01.056-6.88z",
  opacity: 0.5
}));

var SvgStackalt = function SvgStackalt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48
  }, props), _ref);
};

export default SvgStackalt;